/**
 * Dev placeholder (`?screen=results`): a made-up chronicle for six nations (you are 1) with
 * one of every kind of moment, so the results screen's story can be looked at without a match.
 */
import { OUT_DECAP, OUT_TAKEN, STRIKE_CAPITAL, type Chronicle } from '@sa/protocol';

const m = (min: number, sec = 0) => (min * 60 + sec) * 10;

export function sampleChronicle(): Chronicle {
  return {
    entries: [
      { t: m(1, 40), k: 'ceasefire', a: 3, b: 5 },
      { t: m(2, 50), k: 'ally', a: 1, b: 4 },
      { t: m(3, 30), k: 'gift', a: 1, b: 4, n: 2_500 },
      { t: m(4, 0), k: 'leader', a: 2, b: 0, n: 188 },
      { t: m(4, 12), k: 'firstLaunch', a: 6, b: 0, n: 3 },
      { t: m(4, 50), k: 'strike', a: 6, b: 1, n: 3, c: 1, p: 9 },
      { t: m(6, 20), k: 'strike', a: 1, b: 6, n: 6, c: 2, p: 21 },
      { t: m(7, 5), k: 'truceBroken', a: 5, b: 3 },
      { t: m(8, 30), k: 'leader', a: 1, b: 2, n: 254 },
      { t: m(9, 53), k: 'betrayal', a: 1, b: 4 },
      { t: m(10, 20), k: 'strike', a: 1, b: 4, n: 8, c: 1, p: 14, f: STRIKE_CAPITAL },
      { t: m(10, 21), k: 'critical', a: 4, b: 1 },
      { t: m(11, 40), k: 'recovered', a: 4, b: 0 },
      { t: m(12, 8), k: 'out', a: 6, b: 3, f: OUT_DECAP },
      { t: m(13, 30), k: 'strike', a: 3, b: 5, n: 5, p: 11 },
      { t: m(15, 0), k: 'out', a: 5, b: 3, f: OUT_TAKEN },
      { t: m(16, 10), k: 'domination', a: 1, b: 0, n: 66 },
      { t: m(19, 0), k: 'final', a: 1, b: 2, n: 179 },
      { t: m(20, 0), k: 'end', a: 1, b: 0, n: 1, f: 1 },
    ],
    tallies: [1, 2, 3, 4, 5, 6].map((id) => ({ id, onTarget: id === 1 ? 12 : 3, wasted: id === 1 ? 2 : 0, citiesDestroyed: id === 1 ? 3 : 1, shotDown: id === 1 ? 5 : 1, gifted: id === 1 ? 2_500 : 0 })),
  };
}
